import Card from "@mui/material/Card";
import Typography from "@mui/material/Typography";
import { Box } from "@mui/material";
import { ClientCleaningModel } from "./types";
import { getTotalFields } from "../helpers";
import RefreshButton from "../refresh/refresh-button";
import { CACHE_KEYS } from "../../constants/cache-keys";

const SelectCard = ({
  selectedClient,
  mutate,
  dataLength,
}: {
  selectedClient: ClientCleaningModel | undefined;
  mutate: () => void;
  dataLength: number | undefined;
}) => {
  return (
    <Card
      sx={{
        padding: "12px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <Box sx={{ display: "flex", flexDirection: "row", gap: "12px" }}>
        <Typography variant="body2" color="text.secondary">
          Total Entities: {selectedClient?.entityData.length}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Total Field Data: {getTotalFields(selectedClient?.entityData)}
        </Typography>
      </Box>
      <Box>
        <RefreshButton
          mutate={mutate}
          cacheKey={CACHE_KEYS.CLEANING_DATA}
          dataLength={dataLength}
        />
      </Box>
    </Card>
  );
};

export default SelectCard;
